export const ACCEPTED_UPLOAD_TYPES = {
  PDF: { "application/pdf": [".pdf"] },
  CSV: { "text/csv": [".csv"] }
};

export const DEFAULT_TITLE = "File upload";
export const REPLACE_TITLE = "Replace file";
export const DEFAULT_CTA_TEXT = "Browse";
export const DRAG_DROP_CTA = "Drag & drop your files here or";
export const UPLOAD_SUCCESS = "Uploaded Successfully";

export const TEST_IDS = {
  DIALOG: "file-upload-dialog",
  DROP_ZONE: "data-source-file-drop-zone",
  UPLOADED_FILES_LIST: "uploaded-files-list",
  UPLOAD_BUTTON: "upload-button",
  REMOVE_FILE: (index) => `remove-file-${index}`,
  FILE_ERROR: (index) => `file-error-${index}`,
  PROGRESS: "file-upload-progress",
  UPLOAD_SUCCESS: "upload-success",
  DUPLICATE_FILE_ERROR: "duplicate-file-error"
};
